import React from 'react'
import css from './style.css'

const Container = props => (
  <div className={css.container}>
    {props.children}
  </div>
)

export default Container



// WEBPACK FOOTER //
// ./src/components/container/index.js